import React from 'react'
import { UserProvider } from './UserProvider'
export { useUser } from './UserProvider'

export const Providers: React.FC<{ children?: React.ReactNode }> = ({
  children
}) => <UserProvider>{children}</UserProvider>
